import { render } from "./CatalogSectionView.vue?vue&type=template&id=26cc9d20&scoped=true"
import script from "./CatalogSectionView.vue?vue&type=script&lang=js"
export * from "./CatalogSectionView.vue?vue&type=script&lang=js"

import "./CatalogSectionView.vue?vue&type=style&index=0&id=26cc9d20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26cc9d20"]])

export default __exports__